/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Tab_QuestionsInputs */

const en_faq_tab_questions = /** @type {(inputs: Faq_Tab_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const fr_faq_tab_questions = /** @type {(inputs: Faq_Tab_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Faq_Tab_QuestionsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_tab_questions = /** @type {((inputs?: Faq_Tab_QuestionsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Tab_QuestionsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_tab_questions(inputs)
	return fr_faq_tab_questions(inputs)
});